import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  addInterestImage,
  removeInterestImage,
} from "@/lib/api/interest-images";

export const useAddInterestImage = (mentorId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      interest,
      file,
    }: {
      interest: string;
      file: File;
    }) => addInterestImage(mentorId, interest, file),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["user", mentorId] });
    },
  });
};

export const useRemoveInterestImage = (mentorId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      interest,
      imageUrl,
    }: {
      interest: string;
      imageUrl: string;
    }) => removeInterestImage(mentorId, interest, imageUrl),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["user", mentorId] });
    },
  });
};
